export default "__VITE_ASSET__D586sV$l__"